import ResetPasswordConfirmForm from 'components/ResetPasswordConfirmForm';

export default function ResetPassword() {
  return <ResetPasswordConfirmForm />;
}
